import type { PlaceId } from "./ids";
import type { Visibility } from "./user";
import type { VisitRecord } from "./visit";
import type { Stamp, AwardedStamp } from "./stamp";
import { toVisibility } from "./narrow";

/** GET /passport 실측 응답. 빈 여권과 채워진 여권이 같은 스키마다 (AC-06). */
export interface PassportCity { name: string; count: number }
export interface PassportMonth { month: string; count: number }
export interface PassportTag { name: string; count: number }
export interface PassportMapPoint { id: PlaceId; name: string; latitude: number; longitude: number }

export interface Passport {
  displayName: string;
  totalPlaces: number;
  totalEvents: number;
  visibility: Visibility;
  cities: PassportCity[];
  monthlyActivity: PassportMonth[];
  tagActivity: PassportTag[];
  stamps: Stamp[];
  timeline: VisitRecord[];
  visitedMap: PassportMapPoint[];
}

export type PassportSummary = Omit<Passport, "timeline" | "visibility" | "visitedMap">;

export interface ShareCard {
  displayName: string;
  logoText: string;
  totalPlaces: number;
  totalEvents: number;
  cities: PassportCity[];
  stamps: Stamp[];
}

/** POST /visits 응답. awardedStamps 가 비어 있지 않으면 STAMP Motion. */
export interface VisitResult {
  visit: VisitRecord;
  awardedStamps: AwardedStamp[];
  checkinId?: string;
}

/** 서버 DTO(상태값이 string)를 도메인 타입으로 좁힌다. 모르는 값은 비공개로 떨어진다. */
export function toPassport(dto: Omit<Passport, "visibility" | "timeline"> & {
  visibility: string;
  timeline: Array<Omit<VisitRecord, "visibility"> & { visibility: string }>;
}): Passport {
  return {
    ...dto,
    visibility: toVisibility(dto.visibility),
    timeline: dto.timeline.map((v) => ({ ...v, visibility: toVisibility(v.visibility) })),
  };
}

/** I-PS-01: Passport 는 파생 뷰다. 테이블을 만들지 않는다. */
export function isEmptyPassport(p: Pick<Passport, "totalPlaces" | "totalEvents">): boolean {
  return p.totalPlaces === 0 && p.totalEvents === 0;
}
export function shouldCelebrate(r: Pick<VisitResult, "awardedStamps">): boolean {
  return r.awardedStamps.length > 0;
}
